
const HPConditionTypes = {
    CompletionCertificate: 39,
    Invoice: 40,
    HIC: 56,
    InitialBuildingPermitPaperwork: 41,
    ProofFinalPermitInspection: 42,
    ProofInitialFinalPermit: 46,
    SolarLeasePPAAgreement: 44,

};

export default HPConditionTypes;



// WEBPACK FOOTER //
// ./src/app/config/constants/ConditionTypes.constant.js